<template>
    <v-container>
        <v-row justify="center">
            <v-col cols="12">
                <v-select
                        :label="language=='Ελληνικά'? 'Τύπος' : 'Type'"
                        clearable
                        color="#ad282d"
                        :items="types"
                        v-model="filter.category"
                        max-width= "60px"
                ></v-select>
            </v-col>

            <v-col cols="12" xs="6" sm="6" md="6" lg="6" justify="center" align="center">
                <v-btn color="#1b2f5a" class="white--text" @click="$emit('fetchData',filter)">{{language=='Ελληνικά'? 'Εφαρμογη' : 'Submit'}}</v-btn>
            </v-col>
            <v-col cols="12" xs="6" sm="6" md="6" lg="6" justify="center" align="center">
                <v-btn dark color="#ad282d" @click="resetFilters()">{{language=='Ελληνικά'? 'Καθαρισμος' : 'Clear'}}</v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import restApi from "@/rest-api";

    export default {
        data() {
            return {
                filter:{},
                offer: false,
                types: [],
                addresses: [],
                titles: []
            }
        },
        watch:{
            $route(to, from) {
                if(to !== from ) {
                    this.data = this.fetchFilters();
                }
            },
        },
        created() {
            this.fetchFilters();
        },
        computed: {
            language() {
                return this.$store.getters.getLanguage.language
            },
        },
        methods: {
            fetchFilters() {
                this.fetchTypes();
                this.offer = true;
            },
            resetFilters() {
                this.filter = {}
                this.$emit('fetchData',this.filter)
            },
            fetchTypes() {
                var search = ``;
                search = `/partner/types`;
                restApi
                .get(search)
                .then(response => {
                    this.types = response.map(type => type.type);
                   })
                .catch((error) => {
                    console.log(error);
                });
            },
        }
    }
</script>
<style lang="scss" scoped>

</style>
